"use client"; 
import { useState } from "react";
import Link from "next/link";
import CustomButton from "../Buttons/CustomButton";
import cl1Tab from "@/Helper/images/client_centric_approach.png";
import cl2Tab from "@/Helper/images/commitment_to_innovation.png";
import cl3Tab from "@/Helper/images/ethical_data_practices.png";
import cl4Tab from "@/Helper/images/end_to_end_expertise.png";

import Image from "next/image";

export default function IndustryComponent() {
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  const handleTabClick = (index) => {
    setActiveTab(index); // Update the active tab state
  };

  const tabTitles = [
    "End-to-End Visibility",
    "Optimized Operations",
    "Predictive Intelligence",
    "Data-Driven Decisions",
    "Custom Solutions for Complex Needs",
    
   
  ];

  const tabContent = [
    {
      heading: "End-to-End Visibility",
      subheading: " We provide comprehensive analytics solutions that deliver real-time visibility into every stage of your supply chain, enabling proactive decision-making.",
      image: cl1Tab, 
    },
    {
      heading: "Optimized Operations",
      subheading: " Our advanced models and dashboards identify inefficiencies, reduce costs, and streamline operations for maximum productivity. ",
      image: cl2Tab,
    },
    {
      heading: "Predictive Intelligence",
      subheading: " Leveraging AI and ML, we help forecast demand, manage inventory, and mitigate risks, ensuring a resilient and agile supply chain.",
      image: cl3Tab,
    },
    {
      heading: "Data-Driven Decisions",
      subheading: " With actionable insights at your fingertips, our analytics empower you to make informed choices that drive profitability and customer satisfaction.",
      image: cl4Tab,
    },
    {
      heading: "Custom Solutions for Complex Needs",
      subheading: " We tailor our analytics frameworks to align with your unique supply chain challenges, providing solutions that adapt to your business dynamics.",
      image: cl4Tab,
    },
   
  ];

  return (
    <div className="industry_cat_section1">
      {/* Navigation Tabs */}
      <div className="industry_cat_nav1">
        {tabTitles.map((tab, index) => (
          <p
            key={index}
            className={index === activeTab ? "active" : ""}
            onClick={() => handleTabClick(index)}
            
          >
            {tab}
          </p>
        ))}
      </div>

      {/* Tab Content */}
      {tabContent.map((content, index) => (
        <div
          key={index}
          className={`industry_container1 ${
            index === activeTab ? "active" : ""
          }`}
        >
          <div className="industry_left_content1">
            <p className="heading1">{content.heading}</p>
            <p className="subheading1">{content.subheading}</p>
            
          </div>
          <div className="industry_right_content1">
            <div className="slider_bg1 normal_bg1">
            <Image
              src={tabContent[activeTab].image}
              alt={tabContent[activeTab].heading}
              width={457}
              height={257}
              className="productbanner_imageslider"
              loading="eager"
            />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
